<template>
  <div class="componentSty">
    <m-title :titlelist="listitem"></m-title>
    <div class="componentSty_content">
      <div class="componentSty_content_title">
        <span class="fonints">计划单号</span>
        <el-input placeholder="请输入关键词" v-model="conditions.pno" clearable>
        </el-input>
        <span class="fonints">计划来源</span>
        <el-select v-model="conditions.storename" class="m-2" clearable>
          <el-option
            v-for="item in changdisel"
            :key="item.value"
            :label="item.label"
            :value="item.value"
          />
        </el-select>
        <span class="fonints">车牌号码</span>
        <el-input
          placeholder="请输入关键词"
          v-model="conditions.plate"
          clearable
        >
        </el-input>

        <!-- <span class="fonints">派车账号</span>
        <el-input
          placeholder="请输入关键词"
          v-model="conditions.paichename"
          clearable
        >
        </el-input> -->
        <span class="fonints">车队名称</span>
        <el-input
          placeholder="请输入关键词"
          v-model="conditions.shortname"
          clearable
        >
        </el-input>
        <span class="fonints">货主</span>
        <el-input
          placeholder="请输入关键词"
          v-model="conditions.customname"
          clearable
        >
        </el-input>
        <span class="fonints">货代</span>
        <el-input
          placeholder="请输入关键词"
          v-model="conditions.agentname"
          clearable
        >
        </el-input>
      </div>
      <div class="componentSty_content_title">
        <span class="fonints">排放标准</span>
        <el-select v-model="conditions.discharge" class="m-2" clearable>
          <el-option
            v-for="item in dischargeoptions"
            :key="item.val"
            :label="item.val"
            :value="item.val"
          />
        </el-select>
        <span class="fonints">磅单来源</span>
        <el-input
          placeholder="请输入关键词"
          v-model="conditions.custmername"
          clearable
        >
        </el-input>
        <span class="fonints">船名</span>
        <el-input
          placeholder="请输入关键词"
          v-model="conditions.shipname"
          clearable
        >
        </el-input>
        <span class="fonints">时间选择</span>
        <!-- <el-date-picker
          v-model="datamsg"
          type="datetimerange"
          value-format="yyyy-MM-dd HH:mm:ss"
          range-separator="至"
          start-placeholder="开始日期"
          end-placeholder="结束日期"
        >
        </el-date-picker> -->
        <el-date-picker
            v-model="startday"
            type="datetime"
            style="width: 180px;"
            value-format="yyyy-MM-dd HH:mm:ss"
            placeholder="开始日期">
          </el-date-picker>
          <span class="fonints" style="margin: 0;">至</span>
          <el-date-picker
            v-model="endday"
            type="datetime"
            style="width: 180px;"
            value-format="yyyy-MM-dd HH:mm:ss"
            placeholder="结束日期">
          </el-date-picker>
       
      </div>
      <div class="componentSty_content_title_flex">
        <div class="componentSty_content_title">
        <div class="cheboxSty">
          <el-checkbox-group v-model="conditions.duojiacanshu">
            <el-checkbox
              v-for="item in MyCheckboxList"
              :label="item.status"
              :key="item.name"
              >{{ item.name }}</el-checkbox
            >
          </el-checkbox-group>
        </div>
        <div class="cheboxSty" style="margin-left:20px">
          <el-radio-group v-model="radio" @input="getpadio">
            <el-radio
              v-for="item in MyCheckboxList2"
              :label="item.status"
              :key="item.name"
              >{{ item.name }}</el-radio
            >
          </el-radio-group>
        </div>
      </div>
      <div class="componentSty_content_title_flex_button">
        <button class="buttons" @click="querylist">查询</button>
        <button
          class="buttons"
          @click="cleartiaojian"
          style="background: #ff5926"
        >
          清空
        </button>
        <button class="buttons" style="background: #17B6A1" @click="printList">
          导出Excel
        </button>
      </div>
      </div>
      
     
      <div class="componentSty_content_table" style="top: 136px;border:none">
        <el-table
          :data="arrlist.list"
          border
          style="width: 100%; "
          height="80%"
        >
          <el-table-column
            show-overflow-tooltip
            label="序号"
            type="index"
            width="50px"
          ></el-table-column>
          <!-- <el-table-column
            show-overflow-tooltip
            :render-header="renderHeader"
            prop="relevanceId"
            label="焦炭派车号"
          >
          </el-table-column> -->
          <el-table-column
            show-overflow-tooltip :render-header="renderHeader"
            prop="pno"
            label="计划单号"
          ></el-table-column>
          <el-table-column show-overflow-tooltip prop="storename" :render-header="renderHeader" label="计划来源">
            <template slot-scope="scope">
              <div>
                {{ changdi[scope.row.storename ]}}
              </div>
            </template>
          </el-table-column>
          <el-table-column
            show-overflow-tooltip :render-header="renderHeader"
            prop="plantype"
            label="计划类型"
          >
            <template v-slot="scope">
                <span>
                  {{ scope.row.plantype==1?'备货':scope.row.plantype==2?'提货':"港内集疏" }}
                </span>
            </template>
          </el-table-column>
          <el-table-column
            show-overflow-tooltip :render-header="renderHeader"
            prop="shipname"
            label="船名"
          ></el-table-column>
          <el-table-column
            show-overflow-tooltip :render-header="renderHeader"
            prop="customname"
            label="货主"
          ></el-table-column>
          <el-table-column
            show-overflow-tooltip :render-header="renderHeader"
            prop="agentname"
            label="货代"
          ></el-table-column>
          <el-table-column
            show-overflow-tooltip :render-header="renderHeader"
            prop="plate"
            label="车牌号"
          ></el-table-column>
          <el-table-column
            show-overflow-tooltip :render-header="renderHeader"
            prop="discharge"
            label="排放标准"
          ></el-table-column>
          <!-- <el-table-column
            show-overflow-tooltip :render-header="renderHeader"
            prop="paichename"
            label="派车账号"
          ></el-table-column> -->
          <el-table-column
            show-overflow-tooltip :render-header="renderHeader"
            prop="shortname"
            label="车队名称"
          ></el-table-column>
          <el-table-column show-overflow-tooltip label="派车时间">
            <template v-slot="res">
              <span>{{ mydateFormat(res.row.gmtCreate, '时分秒') }}</span>
            </template>
          </el-table-column>
          <el-table-column
            show-overflow-tooltip :render-header="renderHeader"
            prop="custmername"
            label="磅单来源"
          ></el-table-column>
          <el-table-column show-overflow-tooltip :render-header="renderHeader" label="过重时间">
            <template v-slot="res">
              <span>{{ mydateFormat(res.row.mwitemdate, '时分秒') }}</span>
            </template>
          </el-table-column>
          <el-table-column show-overflow-tooltip :render-header="renderHeader" label="过皮时间">
            <template v-slot="res">
              <span>{{ mydateFormat(res.row.pwitemdate, '时分秒') }}</span>
            </template>
          </el-table-column>
          <el-table-column show-overflow-tooltip :render-header="renderHeader" label="毛重">
            <template v-slot="res">
              {{ res.row.roughWeight / 1000 }}
            </template>
          </el-table-column>
          <el-table-column show-overflow-tooltip :render-header="renderHeader"label="皮重">
            <template v-slot="res">
              {{ res.row.tare / 1000 }}
            </template>
          </el-table-column>
          <el-table-column show-overflow-tooltip :render-header="renderHeader" label="净重">
            <template v-slot="res">
              {{ res.row.suttle / 1000 }}
            </template>
          </el-table-column>
          <el-table-column show-overflow-tooltip :render-header="renderHeader" label="状态">
            <template v-slot="res">
              <span v-for="item in statusList"
                :key="item.value"
                :style="'color:'+item.color"
                class="el_spanfontstyle"
                v-show="res.row.status == item.value"
                >{{ item.text }}</span>
            </template>
          </el-table-column>
        </el-table>

        <div class="msgstatistics">
          <span style="margin-right: 20px">合计车次:{{ count }}辆</span>
          <span>合计净重:{{ suttlesum / 1000  }} 吨</span>
        </div>
        <div class="paginations" v-show="arrlist.list && arrlist.list.length">
          <el-pagination
            :page-size="conditions.limit"
            layout="total,prev, pager,next, jumper"
            :total="arrlist.totalCount"
            :current-page="conditions.page"
            @current-change="handleCurrentChange"
          >
          </el-pagination>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import mTitle from '@/components/mTitle';
import { antiShake, printExcel } from '@/plugins/other.js';
import { mapMutations, mapState } from 'vuex';
import {mixins} from "@/mixin"
import changdi from "@/plugins/changdi.json"
export default {
  data() {
    return {
      listitem: [{ name: '统计分析' }, { name: '作业详情' }],
      datamsg: [],
      startday:"",
      endday:"",
      changdi:changdi,
      MyCheckboxList: [
        { name: '进行中', status: '10,11,20,30,31,40,42,43,44,45,46,49' },
        { name: '已完成', status: '60' },
        { name: '已取消', status: '61,62,63,64,65,66,69' },
      ],
      MyCheckboxList2: [
        {name:'全部',status:null},
        { name: '备货', status: 1 },
        { name: '提货', status: 2 },
        { name: '港内集疏', status: 3 },
      ],
      radio:null,
      arrlist: { list: [] },
      count: '', //车次
      suttlesum: '', //合计净重
      conditions: {},
      allnum: 0,
      printable: [],
      dischargeoptions: [],
      changdisel: [
        { label: "前沿货场", value: "jiaotan" },
        { label: "港俊货场", value: "gangjun" },
        { label: "昊德", value: "haode" },
        { label: "琦晟", value: "qisheng" },
        { label: "睿鑫", value: "ruixin" },
        { label: "通达", value: "tongda" },
        { label: "富泉", value: "fuquan" },
      ],
    };
  },
  mixins:[mixins],
  computed: {
    ...mapState(['conditionsList']),
  },
  components: {
    mTitle,
  },
  created() {
    this.conditionsList[this.$route.path] ||
      this.createConditions({
        key: this.$route.path,
        val: {
          page: 1,
          limit: 20,
          duojiacanshu: [],
          duojiacanshu2: [],
        },
      });
    this.conditions = this.conditionsList[this.$route.path] || {
      page: 1,
      limit: 20,
      duojiacanshu: [],
      duojiacanshu2: [],
    };
    if(this.$route.query.obj){
      this.radio=JSON.parse(this.$route.query.obj).plantype
      this.conditions.plantype=JSON.parse(this.$route.query.obj).plantype
      this.conditions.storename=JSON.parse(this.$route.query.obj).stname
      this.conditions.pno=JSON.parse(this.$route.query.obj).pno
      this.conditions.startTime=JSON.parse(this.$route.query.obj).startTime
      this.conditions.endTime=JSON.parse(this.$route.query.obj).endTime
      this.conditions.duojiacanshu=['10,11,20,30,31,40,42,43,44,45,46,49','60']
      this.conditions.shortname=JSON.parse(this.$route.query.obj).fleetname?JSON.parse(this.$route.query.obj).fleetname:''
      // this.conditions.status='60'
    }
    this.startday = this.conditions.startTime || '';
    this.endday = this.conditions.endTime || '';
    this.getjobdetails();
    this.getdischargeoptions();
  },
  methods: {
    ...mapMutations(['createConditions']),
    getpadio(){
      console.log(this.radio);
    },
    async getjobdetails(num) {
      num && (this.conditions.limit = num);
      this.conditions.duojiacanshu &&
        (this.conditions.status = this.conditions.duojiacanshu + '');
      // if (this.conditions.duojiacanshu2) {
      //   this.conditions.paymentChannel =
      //     this.conditions.duojiacanshu2.length > 1
      //       ? ''
      //       : this.conditions.duojiacanshu2 + '';
      // }
      let obj = {};
      for (let i in this.conditions) {
        if (i != 'duojiacanshu' && i != 'duojiacanshu2') {
          obj[i] = this.conditions[i];
        }
      }
      obj.plantype=this.radio
      this.conditions.statuss = null;
      // console.log('**********', obj);
      const { data } = await this.$http(
        'api1',
        '/driver/dispatchtruckdrivercar/listdetails',
        'get',
        obj
      );
      if (data.code != 0) return this.$message.error(data.msg);
      this.suttlesum = data.suttlesum;
      this.count = data.count;
      this.arrlist = data.data;
    },
    async getdischargeoptions() {
      const { data } = await this.$http(
        'api1',
        '/sys/dic/list?dictionaryType=排放标准',
        'get'
      );
      if (data.code != 0) return this.$message.error(data.msg);
      this.dischargeoptions = data.data;
    },

    printList() {
      printExcel.call(
        this,
        '/driver/dispatchtruckdrivercar/exportlistdetails',
        '作业详情',
        this.conditions,
        'get'
      );
    },
    querylist() {
      // console.log(this.startday,this.datamsg);
      antiShake((_) => {
        this.conditions.page = 1;
        this.conditions.startTime = this.startday || null;
        this.conditions.endTime = this.endday || null;
        // this.conditions.startTime = this.datamsg[0] || null;
        // this.conditions.endTime = this.datamsg[1] || null;
        this.getjobdetails();
      });
    },
    cleartiaojian() {
      // antiShake((_) => {
        this.switchcheck = 0;
        // this.datamsg = [];
        this.startday=""
        this.endday=""
        this.conditions.plate=null
        this.conditions.storename=null
        this.conditions.pno = null;
        this.conditions.statuss = null;
        this.conditions.status = null;
        this.conditions.startTime = null;
        this.conditions.endTime = null;
        this.conditions.paichename = null;
        this.conditions.shortname = null;
        this.conditions.custmername = null;
        this.conditions.shipname = null;
        this.conditions.customname = null;
        this.conditions.agentname = null;
        this.conditions.discharge=null
        this.getjobdetails();
      // });
    },
    handleCurrentChange(index) {
      if (this.arrlist.totalCount < this.conditions.limit) return;
      this.conditions.page = index;
      this.getjobdetails();
    },
  },
};
</script>
<style lang="scss" src="@/assets/components.scss" scoped></style>
